import React from 'react';

export default function PageFilters({ className = '', children }) {
    const classes = ['page-filters', 'project-filters', className].filter(Boolean).join(' ');
    return <div className={classes}>{children}</div>;
}
